export default function modals() {
  try {
    let btns = document.querySelectorAll("[data-modal-btn]");

    btns.forEach((btn) => {
      let modal = document.querySelector(
        `[data-modal="${btn.getAttribute("data-modal-btn")}"]`
      );

      let close = modal.querySelector(".js-modal-close");

      btn.addEventListener("click", () => {
        modal.classList.add("active");
      });

      close.addEventListener("click", () => {
        modal.classList.remove("active");
      });

      modal.addEventListener("click", (e) => {
        if (e.target == modal) {
          modal.classList.remove("active");
        }
      });
    });
  } catch (e) {}
}
